import { latamCountries } from '@/constants/latamCountries'

export function regionName(region: string) {
  if (latamCountries.has(region)) return 'latam'
  if (!region) return 'us'
  return region
}
